export const sidebarWidth = 320
export const dropdownWidth = 375

export const tabletWidth = 620
export const desktopWidth = 1280

export const breakpointTablet = `@media (min-width: ${tabletWidth}px)`
export const breakpointDesktop = `@media (min-width: ${desktopWidth}px)`



// WEBPACK FOOTER //
// ./src/containers/mymazda/settings.js